export const PHONE_STEP_EVENTS = {
  SEEN: 'UserAccount.SignUpPhoneStepSeen',
  ACTIVATED: 'UserAccount.SignUpPhoneStepActivated',
  SKIPPED: 'UserAccount.SignUpPhoneStepSkipped',
  CLOSED: 'UserAccount.SignUpPhoneStepClosed',
  FAKE_SUBMITTED: 'UserAccount.SignUpPhoneStepFakeSubmitted',
} as const
